import { render, staticRenderFns } from "./LinkTaskModal.vue?vue&type=template&id=579ea212&"
import script from "./LinkTaskModal.vue?vue&type=script&lang=js&"
export * from "./LinkTaskModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports